module.exports = __webpack_public_path__ + "static/favicon-423e0f7f769d5a5a5bc555aca543ece3.png";